import flag1 from "images/new/flags/flag1.png";
import flag2 from "images/new/flags/flag2.png";
import flag3 from "images/new/flags/flag3.png";
import flag4 from "images/new/flags/flag4.png";
import flag5 from "images/new/flags/flag5.png";
import flag6 from "images/new/flags/flag6.png";
import moreFlags from "images/new/flags/more.png";
import React from "react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface HorizontalFlagsProps {
  className?: string;
}

const flags = [
  { id: 1, src: flag1, alt: "UK Flag" },
  { id: 2, src: flag2, alt: "US Flag" },
  { id: 3, src: flag3, alt: "EU Flag" },
  { id: 4, src: flag4, alt: "UAE Flag" },
  { id: 5, src: flag5, alt: "South Africa Flag" },
  { id: 6, src: flag6, alt: "India Flag" },
  { id: 7, src: moreFlags, alt: "More Flags" },
];

const HorizontalFlags: React.FC<HorizontalFlagsProps> = ({ className = "" }) => {
  return (
    <div className={`relative w-full ${className}`}>
      {/* Title Section */}
      <div className="text-center mb-16">
        <h2 className="text-2xl md:text-4xl font-normal mb-5 max-w-5xl mx-auto">Your agile, global electronic money service ally with 120 currencies & growing</h2>
      </div>

      {/* Flags Section */}
      <div className="relative w-full ">
        <div className="flex items-center">
          {/* Left Section - Text and Button */}
          <div className="flex items-center justify-end gap-4 py-2 px-2 bg-[#1C1C1E] relative z-10 rounded-r-full w-9/12 md:w-1/2">
            <span className="text-white text-lg md:text-2xl font-normal whitespace-normal md:whitespace-nowrap">
              <span className="hidden md:inline">Discover our</span> Foreign Exchange
            </span>
            <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center flex-shrink-0">
              <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>

          {/* Right Section - Flags */}
          <div className="flex-grow overflow-hidden -ml-4">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={24}
              slidesPerView={6}
              loop={false}
              autoplay={{
                delay: 7000,
                disableOnInteraction: false,
              }}
              speed={3000}
              className="!overflow-visible"
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                640: {
                  slidesPerView: 4,
                },
                1024: {
                  slidesPerView: 5,
                },
              }}
            >
              {flags.map((flag) => (
                <SwiperSlide key={flag.id} className="!w-auto ml-4">
                  <div className="flex items-center justify-center w-24 h-24 bg-white rounded-full">
                    <img src={flag.src} alt={flag.alt} className="w-20 h-20 object-cover" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalFlags;
